import React from 'react';

interface ButtonProps {
  state: 'green' | 'red' | 'blue'

  label: string;

  onClick?: () => void;
}

const modeMap: Record<string, string> = {
  green: 'bg-light-active-secondary text-gojek-green font-bold',
  red: 'bg-red-100 text-red-500',
  blue: 'bg-blue-200 text-gray-700',
};

const SquareButton: React.FC<ButtonProps> = ({ state = 'green', label, onClick }) => {
  const mode = modeMap[state] || modeMap.red;

  return (
    <button
      type="button"
      className={['px-4 py-3 mb-5 rounded-xl', 'font-medium text-base', mode].join(' ')}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {label}
    </button>
  );
};

export default SquareButton;
